import { Component, OnInit, Inject } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';

import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { GestorService } from './../../../../services/gestor.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { DocumentosComponent } from 'src/app/components/portal-contratista/gestor/formularios/documentos/documentos.component';
import { DetalleService } from 'src/app/services/detalle.service';
import { DocDetalleGestorComponent } from 'src/app/components/portal-contratista/gestor/doc-detalle-gestor/doc-detalle-gestor.component';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-detalle-gestor',
  templateUrl: './detalle-gestor.component.html',
  styleUrls: ['./detalle-gestor.component.scss']
})
export class DetalleGestorComponent implements OnInit {

  detalleGestor: any = {}
  disableInputBox =  true;
  public gestor: any;
  public path: any;
  public documentos: any
  public autorizacion: any
  public nombreArchivo: any
  public documentoSeleccionado1: any
  public documentoSeleccionado2: any
  public documentoSeleccionado3: any
  public documentoSeleccionado4: any
  public documentoSeleccionado5: any
  public documentosActivos:any
  public documentosVista:any
  public contactos: any
  public contacto:any
  public otrosContactos: any
  public todosContactos: any
  userLog:any
  role:any


  constructor(@Inject(MAT_DIALOG_DATA) public info: {
    id: string,
    refreshTabla: any
  }, private formBuilder: FormBuilder, private apollo: Apollo, private gestorService: GestorService,
  private documentoService: DocumentoService, private detalleService: DetalleService, public dialog: MatDialog, private router: Router, private loginService: LoginService) { 
    this.path = this.router.url
    this.getDocumentosByGestor()
    this.userLog = this.loginService.getUserData();
    this.role = this.userLog.rol
    
  }

  ngOnInit(): void {
    this.getContratistaById()
    this.formBuild()
    this.getDocumentosByGestor()   
   /* console.log(this.userLog.cliente?.xtensaBasica)    */

  }

  

  private formBuild(){
    this.detalleGestor = this.formBuilder.group({
      cif: [''],
      nombre: [''],
      codigo: [''],
      nima: [''],
      contacto: this.formBuilder.group({
        nombre:[''],
        mail:[''],
        contratista: this.userLog?.contratista?.id,
      }) 
    })
  }

  getContratistaById(): void{  
    this.apollo.watchQuery<any>({
      query: this.gestorService.getGestorById(),
      variables: {
        id: this.info.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.gestor = data.gestor
        this.contactos = Object.assign([], this.gestor.contratistaContacto);
        console.log(this.contactos); 
        this.contacto = this.contactos.filter((con:any)=> con.contratista === this.userLog.contratista?.id)
        console.log(this.contacto);
        this.otrosContactos = this.contactos?.filter((con:any)=> con.contratista != this.userLog.contratista?.id)
        console.log(this.otrosContactos);
        
        this.displayGestor()
      })
  }

  getDocumentosByGestor(): void{  
    this.apollo.watchQuery<any>({
      query: this.documentoService.getDocumentosByGestor(),
      variables: {
        id: this.info.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.autorizacion = [];
       
      /*   console.log(this.gestor) */
        this.documentos= data.gestor.documentos;
         console.log(data)
        console.log(this.documentos) 
        this.documentoSeleccionado1 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'autorizacion1')
        this.documentoSeleccionado2 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'autorizacion2')
        this.documentoSeleccionado3 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'autorizacion3')
        this.documentoSeleccionado4 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'autorizacion4')
        this.documentoSeleccionado5 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'autorizacion5')
        this.documentosActivos = this.documentos.filter((documento:any)=>documento.tipo != 'inactivo' )
        /* console.log(this.documentosActivos) */
        this.documentosVista = this.documentosActivos.filter((documento:any) => documento.tipo != 'pendiente' || !documento.idPadre)
         /* console.log(this.documentosVista) */
        this.setIndicadores()
      })
  }

  displayGestor(){
    if(this.detalleGestor){
      this.detalleGestor.reset()
    }
    this.detalleGestor.patchValue({
      cif: this.gestor.cif,
      nombre: this.gestor.nombre,
      codigo: this.gestor.codigo,
      nima: this.gestor.nima,
      contacto: {
        nombre: this.contacto[0]?.nombre,
        mail: this.contacto[0]?.mail,
        contratista: this.userLog.contratista?.id,
      }
    })
  }

  disableInput(): void {
    this.disableInputBox = !this.disableInputBox;
  }

  setGestor(){
    this.gestor = {...this.gestor, ...this.detalleGestor.value}
    this.otrosContactos.push(this.detalleGestor.value.contacto)
  }

//HECHO: ACTUALIZAR INFORMACION DE CONTACTO, QUE ES DEPENDIENDO DEL CONTRATISTA, EN EL DETALLE DE INPROECO NO SE VEN LOS CONTACTOS

  updateGestorById(){
    this.setGestor()
    this.apollo.mutate({
      mutation: this.gestorService.updateGestor(),
      variables: {
        "input": {
          "where": {
            "id": this.info.id
          },
          "data": {
            "nombre": this.gestor.nombre,
            "cif": this.gestor.cif,
            "codigo": this.gestor.codigo,
            "nima": this.gestor.nima,
            "nombreContacto": this.gestor.nombreContacto,
            "contratistaContacto": this.otrosContactos,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
        location.reload()
      }, (error) => {
        console.log(error)
      })
  }

   setIndicadores(){
    this.documentos.map((documento: any) => {
      if(documento?.validado === true) {
        this.setDocumentoProximoCaduca()
        this.setDocumentoCaducado()
        this.setDocumentoEnFecha()
      }
    })
  }

  setDocumentoProximoCaduca(){
    this.documentos.map((documento: any) => {
      if(documento?.fechaCaducidad <= this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate()) {
        this.updateDocumentoToProximoCaduca(documento?.id)
      }
    })
  }

  updateDocumentoToProximoCaduca(id: string){
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "proximoCaduca": true,
            "caducado": false,
            "enFecha": false
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

    setDocumentoCaducado(){
    this.documentos.map((documento: any) => {
      if(documento.fechaCaducidad <= this.documentoService.getActualDate()) {
        this.updateDocumentoToCaducado(documento.id)
      }
    })
  }

   updateDocumentoToCaducado(id: string){
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": true,
            "proximoCaduca": false,
            "enFecha":false
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log(error)
      })
  }

  setDocumentoEnFecha(){
    this.documentos.map((documento: any) => {
      if(documento?.fechaCaducidad > this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFecha(documento?.id)
      } else if (documento.noCaduca) {
        this.updateDocumentoToEnFecha(documento?.id)
      }
    })
  }

   updateDocumentoToEnFecha(id: string){
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": false,
            "proximoCaduca": false,
            "enFecha":true
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }


  openDetails(id: string, e:any){
    const options= {
      id: id,
      nAuth: e.target.id,
    }
    this.detalleService.openTest(options, DocumentosComponent);
  }

  openDocumento(id: string){
    const options= {
      id: id,
    }
    this.detalleService.openTest(options, DocDetalleGestorComponent);
  }

  setIdGestor(id: string){
    this.gestorService.setIdGestor(id)
    
  }

}
